import {
  RECEIVE_ORDERS,
  REQUEST_ORDERS
} from 'constants/reduxActions';
import { injectUniqueIdsToLineItems } from 'helpers/MyAccountUtils';

const initialState = {
  orders: null,
  totalPages: null,
  isLoading: false
};

export default function orders(state = initialState, action) {
  const { type, orders, totalPages } = action;

  switch (type) {
    case REQUEST_ORDERS:
      return { ...state, isLoading: true };

    case RECEIVE_ORDERS:
      const newOrders = orders.map(order => ({
        ...order,
        lineItems: injectUniqueIdsToLineItems(order)
      }));
      return { ...state, totalPages, orders: newOrders, isLoading: false };

    default:
      return state;
  }
}
